<td class="mat-cell table-empty-content-container" [attr.colspan]="attrColspan">
  <div class="content display-flex justify-content-center">
    <span class="body-small">{{ message }}</span>
  </div>
</td>
